import { Component } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { NmDatatableSettings } from '../../../widgets/datatable/datatable.interface';
import { HelperService } from '../../../services/helper.service';

import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { DataService } from '../../../services/data.service';
import { FormService } from '../../../services/form.service';

import { ApiService } from '../../../services/api.service';

declare let $: any;
declare let bootbox: any;

@Component({
	selector: 'members-search-page',
	templateUrl: './search.html',
	styleUrls: ['./search.css']
})
export class MembersSearchPage {
	public modelName: string = 'member';
	public reloadTable: boolean = false;
	public searched: boolean = false;
	

	public searchForm: FormGroup = this.formBuilder.group({
		// basic information
		YFSID: [''],
		LegacyYFSID: [''],
		HongKongIdentityCard: [''],
		MemberTypeCode: [''],
		FullName: [''],
		ChineseName: [''],
		SchoolId: [''],
		DateOfBirth: [''],
		EmailAddress: [''],
		Telephone1: [''],
		Telephone2: [''],
		StatusCode: [''],
		year: [''],
		early_bird: [''],
		volunteer_type_id: ['']
	});
	public constructor(
		private helper: HelperService,
		public formBuilder: FormBuilder,

		public data: DataService,
		public _searchForm: FormService,

		private api: ApiService,
		private router: Router,
		private location: Location,
		private activatedRoute: ActivatedRoute
	) {}

	public ngOnInit() {
		if(!this.modelName) console.error('Missing modelName.');

		this._searchForm.setForm(this.searchForm);
		this.onBeforeRendered();
		let params = this.activatedRoute.snapshot.queryParams;
		
		let initSearch: boolean = false;
		for(let key in params){
			if(params[key] && this.searchForm.controls[key]){
				this.searchForm.controls[key].setValue(params[key]);
				initSearch = true;
			}
			if(key == 'searchall'){
				initSearch = true;
			}
		}
		if(initSearch){
			this.onSearch();
		}
		
	}
	public onBeforeRendered() {
		/*let control = <FormArray>this.form.get('_contact_channels');
		for(let channel of this.data.shared.communicationChannels.getValue()) {
			control.push(this.formBuilder.control(false));
		}*/

	}


	
	public onSearch():void{
		//console.log(this.searchForm.value);
		
		let queryStr = [];
		if(this.searchForm.value['year']){
			queryStr.push('year='+this.searchForm.value['year']);
		}
		if(this.searchForm.value['early_bird']){
			queryStr.push('early_bird='+this.searchForm.value['early_bird']);
		}
		if(this.searchForm.value['volunteer_type_id']){
			queryStr.push('volunteer_type_id='+this.searchForm.value['volunteer_type_id']);
		}
		if(queryStr.length > 0){
			this.datatableSetting.ajax.url = 'member/datatables?'+queryStr.join('&');
			
		}else{
			this.datatableSetting.ajax.url = 'member/datatables';
		}
		//console.log(this.datatableSetting);
		let fullMath = ['SchoolId','StatusCode'];
		this.datatableSetting.fields.map(v => {
			for(let k of fullMath){
				if(k == 'SchoolId') {
					if((v.name == 'SchoolId' || v.name == 'MemberParticipationRecord.SchoolId')){
						this.searchForm.value['SchoolId'] ? v.search = this.searchForm.value['SchoolId'] : v.search = '';
						if(v.search){
							if(queryStr.length > 0){
								v.name = 'MemberParticipationRecord.SchoolId';
							}else{
								v.name = 'SchoolId';
							}
							v.regex = true;
							v.search = '^'+v.search+'$';
							// console.log(v);
						}
						
						return v;
					}
				} else {
					this.searchForm.value[v.name] ? v.search = this.searchForm.value[v.name] : v.search = '';
					if(v.search && v.name == k){
						v.regex = true;
						v.search = '^'+v.search+'$';
						return v;
					}
				}
				
			}
			this.searchForm.value[v.name] ? v.search = this.searchForm.value[v.name] : v.search = '';
			if(v.name == 'DateOfBirth'){
				v.search = this.data.datepicker.toString(this.searchForm.value['DateOfBirth']);
			}
			return v;
		});
		// console.log(this.searchForm.value);
		// console.log(this.datatableSetting.fields);
		this.searched = true;
		this._setSearchUrl();
	}
	private _setSearchUrl(){
		let querys = [];
		for(let name in this.searchForm.value){
			if(this.searchForm.value[name]){
				querys.push(name+'='+this.searchForm.value[name]);
			}
		}
		
		let queryStr = querys.join('&');
		if(!queryStr){
			queryStr = 'searchall=1';
		}
		this.location.replaceState('/members/search',queryStr);
		
	}

	public onSearchClear(): void{
		/*$('select').val(null);
		$('select').trigger('chosen:updated');
		this.searchForm.reset();*/
		for(let it in this.searchForm.controls){
			this.searchForm.controls[it].setValue('');
		}
		$('select').val(null);
		$('select').trigger('chosen:updated');
	}
	public onBackSearch(): void{
		this.searched = false;
	}
	public datatableSetting: NmDatatableSettings = {
		modelName: 'member',
		fields: [
			{ name: 'YFSID', label: 'YFS ID', sortable: true, searchable: true,search: '' },
			//{ name: 'LegacyYFSID', label: 'Legacy YFS ID', sortable: true, searchable: true, },
			// { name: 'HongKongIdentityCard', label: 'HKID', sortable: true, searchable: true, },
			{ name: 'MemberTypeCode', label: 'Member type', sortable: true, searchable: true, },
			{ name: 'FullName', label: 'Name (English)', sortable: false, searchable: true, },
			{ name: 'ChineseName', label: 'Name (Chinese)', searchable: true },
			{ data: 'SchoolId',name: 'SchoolId', label: 'School ID', searchable: true },
			{ name: 'PschoolEngName', label: 'School Name (English)' },
			{ name: 'PschoolChiName', label: 'School Name (Chinese)' },
			{ name: 'DateOfBirth', label: 'Date of Birth (dd/mm/yyyy)', searchable: true },
			{ name: 'EmailAddress', label: 'Email', searchable: true },
			{ name: 'Telephone1', label: 'Tel (Home)', searchable: true },
			{ name: 'Telephone2', label: 'Tel (Mobile)', searchable: true },
			{ name: 'StatusCode', label: 'Status', searchable: true },
			{ name: 'Year', label: 'Membership Year', searchable: false },
			{ name: 'early_bird', label: 'Early Birld?', searchable: false }
			
		],
		actions: [
			{ name: 'view', icon: 'search-plus', color: 'blue', show: () => true,
				callback: function(id, data) { this.router.navigate([`/members/view/${id}`]); }
			},
			{ name: 'edit', icon: 'pencil', color: 'green', show: () => true,
				callback: function(id, data) { this.router.navigate([`/members/edit/${id}`]); }
			},
			{ name: 'delete', icon: 'trash', color: 'red', show: () => true },
		],
		ajax: {
			url: 'member/datatables'
		},
		ajaxDataMassage: (data: any[]) => {
			
			return data.map(v => {
				// parse json string
				for(let i of ['name', 'mobile_phone']) {
					if(v[i] && typeof v[i] == 'string')
						v[i] = this.helper.parseJsonString(v[i]);
				}
				v.id = v.MemberId;
				//console.log('sharedata:',this.data);
	
				
				for(let st of this.data.shared.memberOptions['memberStatusList']){
					if(st.value == v.StatusCode){
						v.StatusCode = st.label;
					}
				}
				for(let st of this.data.shared.memberOptions['memberTypes']){
					if(st.value == v.MemberTypeCode){
						v.MemberTypeCode = st.label;
					}
				}
				if(v.DateOfBirth){
					let birthArr:number[] = v.DateOfBirth.split('-');
					v.DateOfBirth = birthArr[2]+'/'+birthArr[1]+'/'+birthArr[0];
				}

				v.FullName = v.Surname+' '+v.GivenName;
				if(v.Year){
					if(v.early_bird){
						v.early_bird = 'Yes';
					}else{
						v.early_bird = 'No';
					}
					v['MemberParticipationRecord.SchoolId'] = v.PSchoolId;
					v.SchoolId = v.PSchoolId;
				}else{
					v.Year = '';
					v.early_bird = '';
					
					v.PschoolEngName = v.school?v.school.NameSchool:'';
					v.PschoolChiName = v.school?v.school.NameChin:'';
					v['MemberParticipationRecord.SchoolId'] = v.SchoolId;
				}
				

				return v;
			})
		}
	};
}



// WEBPACK FOOTER //
// ./src/pages/members/search/search.ts